import { inject } from "fw";
import { createFrom } from "fw-model";
import { Manager } from "./manager";
import { wait } from "wait";
import { CasOrganizationIntegration, CasOrganizationIntegrationClientModel } from "models/cas-organization-integration";

export interface ICasOrganizationIntegrationEnvironment {
    Name: string;
    Environment: string;
}

@inject
export class CasOrganizationIntegrationRepository {
    constructor(private s: Manager) {}

    async post(integration: CasOrganizationIntegration, atsOrganizationId: string, providerType: string) {
        const res = await this.s.post<CasOrganizationIntegration>("cas-org-integration", integration, { atsOrganizationId, providerType });
        await wait(1000);
        return res.body;
    }

    async put(id: string, integration: { AutoProvisionPrograms: boolean; AutoProvisionProgramTemplateId: string; Enabled: boolean }) {
        const res = await this.s.put<CasOrganizationIntegration>(`cas-org-integration/${id}`, integration);
        return res.body;
    }

    async get(id: string) {
        const res = await this.s.get<CasOrganizationIntegration>(`cas-org-integration/${id}`);
        return createFrom(CasOrganizationIntegration, res.body);
    }

    async getClientModel(id: string) {
        const res = await this.s.get<CasOrganizationIntegrationClientModel>(`cas-org-integration/${id}/client-model`);
        return createFrom(CasOrganizationIntegrationClientModel, res.body);
    }

    async listByMappingId(atsOrganizationMappingId: string) {
        const res = await this.s.get<CasOrganizationIntegration[]>("cas-org-integration", { atsOrganizationMappingId });
        return res.body;
    }

    async delete(id: string) {
        await this.s.delete(`cas-org-integration/${id}`);
        await wait(1000);
    }

    async listEnvironments() {
        const res = await this.s.get<ICasOrganizationIntegrationEnvironment[]>("cas-org-integration/environments");
        return res.body;
    }
}
